// components/Menu.jsx
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./menu.css";

const Menu = () => {
  const { isAuthenticated, userName, userRole, photo, logout } = useAuth();
  const navigate = useNavigate();
  const admin = process.env.REACT_APP_ADMINROLE;
  const defaultAvatar = "https://www.gravatar.com/avatar/?d=mp";

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="menu">
      <div className="menu-width">
        <div className="header-text">
          <img
            src={isAuthenticated && photo ? photo : defaultAvatar}
            alt=""
            className="profile-pic"
          />
          <span className="username">
            {isAuthenticated ? userName : "Niet ingelogd"}
          </span>
        </div>
        <ul>
          {isAuthenticated && userRole && (
            <>
              <li className="link">
                <NavLink
                  to="/afas"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  AFAS
                </NavLink>
              </li>
              {userRole === admin && (
                <li className="link">
                  <NavLink
                    to="/users"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Beheer
                  </NavLink>
                </li>
              )}
              <li className="link">
                <NavLink to="/" onClick={handleLogout}>
                  Uitloggen
                </NavLink>
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Menu;
